import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function Login({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
   const [showPassword, setShowPassword] = useState(false);

  const handleSignin = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setErrorMessage("Email is required");
      return;
    }
    if (!password.trim()) {
      setErrorMessage("Password is required");
      return;
    }

    axios
      .post(process.env.REACT_APP_APIURL + "business/login", { email_address: email, password })
      .then((res) => {
        if (res.data.status === "success") {
          window.localStorage.setItem("email_address", email);
          window.localStorage.setItem("user_id", res.data.result._id);
          window.localStorage.setItem("signup", res.data.result.signup);
          if (res.data.result.signup === "user") {
            window.localStorage.setItem("business_id", res.data.result._id);
          }

          toast.success("User logged in successfully");
          setIsLoggedIn(true);

          setTimeout(() => {
            navigate("/gift");
          }, 2000); // Delay navigation for 2 seconds
        } else {
          if (res.data.error && res.data.error.message) {
             toast.error("Email not found. Please check or sign up.");
          } else {
             toast.error(res.data.error.message);
          }
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
        toast.error("The email or password you entered is incorrect.");
      });
  };

  return (
    <div className="login-box login_div">
      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <a href="/" className="login_logo">
            <img src="assets/img/logo.png" border={0} alt="Logo" />
          </a>
        </div>
         
        <div className="card-body d-flex flex-row flex_flow_rowwrap">
          <div className="col-12 col-sm-12 col-md-12">
            <h5 className="login-box-msg mb-3">Business Login</h5>

            {successMessage && (
              <div className="alert alert-success alert-dismissible fade show" role="alert">
                {successMessage}
                <button type="button" className="close" onClick={() => setSuccessMessage("")} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
            {errorMessage && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                {errorMessage}
                <button type="button" className="close" onClick={() => setErrorMessage("")} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}

            <form onSubmit={handleSignin}>
             <div className="mb-3">
  <label className="form-label">
    Email <span style={{ color: "red" }}>*</span>
  </label>
  <div className="input-group">
    <input
      type="email"
      className="form-control"
      placeholder="Your Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />
    <div className="input-group-append">
      <div className="input-group-text">
        <i className="fa-solid fa-user" />
      </div>
    </div>
  </div>
</div>


             <div className="mb-3">
  <label className="form-label">
    Password <span style={{ color: "red" }}>*</span>
  </label>
  <div className="input-group">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control"
      placeholder="Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />
    <div className="input-group-append">
      <div
        className="input-group-text"
        onClick={() => setShowPassword(!showPassword)}
        style={{ cursor: "pointer" }}
      >
        <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"} />
      </div>
    </div>
  </div>
</div>


              <div className="row">
                <div className="col-12 mt-3">
                  <button type="submit" className="btn btn-primary btn-block">
                    Login
                  </button>
                </div>

                {/* <div>
                  <p>Forgot Password</p>
                </div> */}

                <div class="col-12 mt-3" style={{ paddingLeft: '200px' }}>
                  <p >Don't have an account?<a href="/signup" style={{ paddingLeft: '5px' }}>sign up</a> </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
     
    </div>
  );
}

export default Login;
